import { Link } from 'react-router-dom';
import BrandLogo from '../../components/ui/BrandLogo';

export default function MentionsLegales() {
    return (
        <div className="legal-page">
            <div className="legal-inner">
                <h1>Mentions l&eacute;gales</h1>

                <h2>1. &Eacute;diteur du site</h2>
                <p>
                    <strong>monquiz.fr</strong> est &eacute;dit&eacute; par :<br />
                    Fabien Nicolet<br />
                    Entrepreneur individuel (EI)<br />
                    SIREN : 749 975 116<br />
                    SIRET : 749 975 116 00064<br />
                    32 rue Camille Besan&ccedil;on, 25110 Baume-les-Dames, France<br />
                    Contact : <a href="mailto:contact@monquiz.fr">contact@monquiz.fr</a>
                </p>

                <h2>2. H&eacute;bergement</h2>
                <p>
                    Le site est h&eacute;berg&eacute; par :<br />
                    o2switch<br />
                    222 Boulevard Gustave Flaubert, 63000 Clermont-Ferrand, France<br />
                    T&eacute;l&eacute;phone : 04 44 44 60 40<br />
                    Site web : <a href="https://www.o2switch.fr" target="_blank" rel="noopener noreferrer">www.o2switch.fr</a>
                </p>

                <h2>3. Directeur de la publication</h2>
                <p>Fabien Nicolet</p>

                <h2>4. Propri&eacute;t&eacute; intellectuelle</h2>
                <p>
                    L&rsquo;ensemble du contenu du site monquiz.fr (textes, questions, images, logo,
                    structure) est prot&eacute;g&eacute; par le droit d&rsquo;auteur. Toute reproduction,
                    m&ecirc;me partielle, est interdite sans autorisation &eacute;crite pr&eacute;alable.
                </p>

                <h2>5. Donn&eacute;es personnelles</h2>
                <p>
                    Les donn&eacute;es personnelles collect&eacute;es sont trait&eacute;es conform&eacute;ment
                    au RGPD. Consultez notre <Link to="/confidentialite">politique de confidentialit&eacute;</Link> pour
                    plus de d&eacute;tails.
                </p>

                <h2>6. Cookies</h2>
                <p>
                    Le site utilise des cookies n&eacute;cessaires au fonctionnement (authentification)
                    et, avec votre consentement, des cookies d&rsquo;analyse (Google Analytics).
                    Vous pouvez g&eacute;rer vos pr&eacute;f&eacute;rences via la banni&egrave;re cookies.
                </p>

                <h2>7. Limitation de responsabilit&eacute;</h2>
                <p>
                    Les questions et contenus propos&eacute;s sur monquiz.fr sont fournis &agrave; titre
                    p&eacute;dagogique. Bien qu&rsquo;ils soient r&eacute;dig&eacute;s et v&eacute;rifi&eacute;s
                    avec soin, l&rsquo;&eacute;diteur ne garantit pas l&rsquo;absence d&rsquo;erreurs et ne
                    saurait &ecirc;tre tenu responsable des r&eacute;sultats obtenus aux concours et examens.
                </p>

                <div className="legal-footer">
                    <Link to="/">&larr; Retour &agrave; l&rsquo;accueil</Link>
                </div>
            </div>
        </div>
    );
}
